/*
 * @Author: Teemo Ding
 * @Date: 2022-02-14 16:38:03
 * @LastEditTime: 2022-02-22 15:20:26
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/communication/index.ts
 */
import { get, post, remove } from 'src/tools/server';

export const getCommunicationGateways = (p?) => {
  return get<any>('/portal/communication/gateways', p || {});
};

export const saveCommunicationGateway = (data) => {
  return post<any>('/portal/communication/gateway', data, {});
};
export const deleteCommunicationGateway = (gatewayUuid) => {
  return remove<any>(`/portal/communication/gateway/${gatewayUuid}`, {});
};

export const initializeCommunicationGateway = (data) => {
  return get<any>('/portal/communication/gateway/initialize', {
    params: data,
  });
};

export const initializeCommunicationTemplate = (data) => {
  return get<any>('/portal/communication/template/initialize', {
    params: data,
  });
};

export const saveTemplate = (data) => {
  return post<any>('/portal/communication/template', data, {});
};

export const deleteTemplate = (templateUuid) => {
  return remove<any>(`/portal/communication/template/${templateUuid}`, {});
};
